import React, { useEffect, useState } from "react";
import {
  useCreateAnnouncementMutation,
  useDeleteAnnouncementMutation,
  useGetAnnouncementByIdQuery,
  useUpdateAnnouncementMutation,
} from "../../redux/announcementApi";
import { useNavigate, useParams } from "react-router-dom";

import { formatDateForInput, showErrorToast } from "../../utils/Utils";
import ButtonLoading from "../Button loading/ButtonLoading";
import { toast } from "react-toastify";
import { showConfirmDialog } from "../showConfirmDialog/ShowConfirmDialog";

export const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

const AddAnnouncement = () => {
  const [formData, setFormData] = useState({
    title: "",
    announcementDate: getTodayDate(),
    description: "",
  });
  const [createAnnouncement, { isLoading: isCreateLoading }] =
    useCreateAnnouncementMutation();
  const [updateAnnouncement, { isLoading: isUpdateLoading }] =
    useUpdateAnnouncementMutation();
  const [deleteAnnouncement, { isLoading: isDeleteLoading }] =
    useDeleteAnnouncementMutation();

  const { id } = useParams();
  const isEditMode = Boolean(id);

  const { data, isLoading: isAnnouncementLoading } =
    useGetAnnouncementByIdQuery(id, {
      refetchOnFocus: false,
      skip: !isEditMode,
    });

  useEffect(() => {
    if (isEditMode && data) {
      setFormData({
        title: data?.announcement?.title,
        announcementDate: formatDateForInput(
          data?.announcement?.announcementDate
        ),
        description: data?.announcement?.description,
      });
    }
  }, [isEditMode, data]);

  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.title.trim()) {
      newErrors.title = "Title is required.";
      isValid = false;
    } else if (formData.title.trim().length < 10) {
      newErrors.description = "Title must be at least 10 characters long.";
      isValid = false;
    } else if (formData.title.trim().length > 100) {
      newErrors.description = "Title must not exceed 100 characters.";
      isValid = false;
    }

    if (!formData.description.trim()) {
      newErrors.description = "Description is required.";
      isValid = false;
    } else if (formData.description.trim().length < 100) {
      newErrors.description =
        "Description must be at least 100 characters long.";
      isValid = false;
    } else if (formData.description.trim().length > 800) {
      newErrors.description = "Description must not exceed 800 characters.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    // const announcementData = new FormData();
    // announcementData.append("title", formData.title);
    // announcementData.append("announcementDate", formData.announcementDate);
    // announcementData.append("description", formData.description);

    try {
      let response = null;
      if (isEditMode) {
        response = await updateAnnouncement({
          id,
          announcementData: formData,
        }).unwrap();
      } else {
        response = await createAnnouncement(formData).unwrap();
      }

      if (response.success) {
        handleCancel();
        toast.success(response.message);

        navigate("/announcement");
      }
    } catch (err) {
      console.error("announcement error:", err);
      showErrorToast(err);
    }
  };

  const handleCancel = () => {
    setFormData({
      title: "",
      description: "",
      announcementDate: "",
    });
    setErrors({});
  };

  const handleDeleteAnnouncement = async (id) => {
    try {
      const response = await deleteAnnouncement(id).unwrap();
      if (response.success) {
        toast.success(response.message);
        navigate("/announcement");
      }
    } catch (err) {
      console.error("Announcement error:", err);
      showErrorToast(err);
    }
  };

  const handleDeleteConfrim = (id) => {
    showConfirmDialog({
      title: "Delete Announcement",
      message: "Are you sure you want to delete this announcement?",
      type: "danger",
      onConfirm: () => {
        handleDeleteAnnouncement(id);
      },
    });
  };

  return (
    <div className="flex flex-col gap-3 bg-white rounded-xl xl:p-8 lg:p-6 p-4 ">
      <h1 className="text-[#05004E] lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem] font-semibold">
        {isEditMode ? "Update" : "Add"} Announcement
      </h1>
      {isAnnouncementLoading ? (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
            <div className=" w-full h-12 rounded-xl bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="flex flex-col gap-1 w-[50%]">
            <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
            <div className=" w-full h-12 rounded-xl bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="flex flex-col gap-1 ">
            <div className="h-6 w-40 bg-[#efefef] animate-pulse rounded-lg"></div>
            <div className=" w-full h-24 rounded-xl bg-[#efefef] animate-pulse"></div>
          </div>
          <div className="flex items-center justify-end gap-4">
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
            <div className="w-[10rem]  rounded-xl h-14 bg-[#efefef] animate-pulse"></div>
          </div>
        </div>
      ) : (
        <form
          className="flex flex-col lg:gap-4 md:gap-3 gap-2 lg:text-[1rem] text-[.9rem]"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col md:gap-1 gap-[2px] ">
            <label className="font-semibold">Title</label>
            <input
              type="text"
              name="title"
              placeholder="Enter Title"
              value={formData.title}
              onChange={handleChange}
              className="w-full border border-[#00000033] text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
            />
            {errors.title && (
              <p className="text-red-500 md:text-sm text-[12px]">
                {errors.title}
              </p>
            )}
          </div>
          <div className="flex flex-col md:gap-1 gap-[2px] md:w-[50%] sm:w-[70%] w-full ">
            <label className="font-semibold">Announcement Date</label>
            <input
              type="date"
              name="announcementDate"
              placeholder="24/03/2025"
              value={formData.announcementDate}
              onChange={handleChange}
              className="w-full border border-[#00000033] text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
            />
          </div>
          <div className="flex flex-col md:gap-1 gap-[2px] ">
            <label className="font-semibold">Description</label>
            <textarea
              name="description"
              rows="5"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter description... "
              className="w-full border border-[#00000033]  text-[#737791] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
            ></textarea>

            {errors.description && (
              <p className="text-red-500 md:text-sm text-[12px]">
                {errors.description}
              </p>
            )}
          </div>
          <div className="flex items-center justify-end lg:gap-4 md:gap-3 gap-2">
            <p
              onClick={() => handleCancel()}
              className="lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border  border-[#00643B] text-[#00643B] text-center cursor-pointer  lg:rounded-xl md:rounded-lg rounded-md font-medium"
            >
              Cancel
            </p>
            {data || isEditMode ? (
              <div
                disabled={isDeleteLoading ? true : false}
                onClick={() => handleDeleteConfrim(data?.announcement?._id)}
                className={`lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border text-center border-[#D80000] flex items-center justify-center ${
                  isDeleteLoading
                    ? "opacity-50 cursor-not-allowed"
                    : "opacity-100 cursor-pointer"
                } text-white bg-[#D80000] lg:rounded-xl md:rounded-lg rounded-md font-medium`}
              >
                {isDeleteLoading ? (
                  <ButtonLoading text=" Delete..." />
                ) : (
                  "Delete"
                )}
              </div>
            ) : (
              ""
            )}
            <button
              type="submit"
              disabled={isCreateLoading || isUpdateLoading ? true : false}
              className="lg:w-[10rem] md:w-[9rem] w-max md:py-2 md:px-0 py-1 px-2 md:text-[1rem] text-[.85rem]  border border-[#00643B] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center text-white bg-[#00643B] lg:rounded-xl md:rounded-lg rounded-md font-medium"
            >
              {isEditMode ? (
                isUpdateLoading ? (
                  <ButtonLoading text="Update..." />
                ) : (
                  "Update"
                )
              ) : isCreateLoading ? (
                <ButtonLoading text="Add..." />
              ) : (
                "Add"
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddAnnouncement;
